<template>
    <div class="c-cart-box__list">

      <div class="c-cart-box__list--actionfirst">
        <BlockCartActions :isLogged="true" :linkOrder="linkOrder" :isFirst="true" v-if="products.length > 0" />
      </div>
      <BlockCartSummary name="Twoje produkty" :value="productTotal" isAlt="true" v-if="products.length > 0" />

      <div class="c-cart-box__list__item" v-for="(product, index) in products" :key="index">
        <div class="c-product-box c-product-box--alt">
          <figure class="c-product-box__pic">
            <a :href="product.link">
                <picture>
                  <source :data-srcset="product.imageWebp" :srcset="product.imageWebp" type="image/webp">
                  <source :data-srcset="product.image" :srcset="product.image" type="image/jpeg">
                  <img class="lazy-picture" :data-src="product.image" :src="product.image">
                </picture>
            </a>
          </figure>
          <div class="c-product-box__main">
            <h4 class="c-product-box__brand t-head t-head--alt" v-if="product.manufacturer_name">
              {{ product.manufacturer_name }}
            </h4>
            <h3 class="c-product-box__title t-head t-head--comp">
              <a :href="product.link">
                {{ product.full_name }}
              </a>
            </h3>
            <h4 class="c-product-box__brand t-head t-head--alt" v-if="product.hasAttributes">
              <a :href="product.attributes_link">
                {{ product.attributes }}
              </a>
            </h4>

            <div class="c-product-box__foot">
              <div class="c-product-box__price c-product-price" v-if="!product.is_gift">
                <span class="c-product-price__label">
                  {{ product.price }}
                </span>
                <span v-if="product.quantity > 1" class="c-product-price_piece__label">
                  Cena za szt: {{ product.price_piece }}
                </span>
              </div>
              <div class="c-counter">
                <button type="button" class="c-btn c-btn--theme-9 c-counter__btn" @click="changeQuantity(index, 1, product.quantity, 'down')">-</button>
                  <span class="c-counter__label">{{ product.quantity }}</span>
                <button type="button" class="c-btn c-btn--theme-9 c-counter__btn" @click="changeQuantity(index, 1, product.quantity, 'up')">+</button>
              </div>
            </div>
            <button type="button" class="c-product-box__btn c-btn c-btn--ico" v-on:click="$emit('deleteProduct', index)">
              <span class="o-ico o-ico--cancel o-ico--m">
                <svg><use xlink:href="#ico-cancel"></use></svg>
              </span>
            </button>
          </div>
        </div>
      </div>
      <div class="c-cart-sum" v-if="products.length > 0">
        <p class="c-cart-sum__label">Dostawa</p>
        <p class="c-cart-sum__label">od 9,90 zł</p>
      </div>
      <div class="c-cart-sum" v-if="products.length > 0">
        <p class="c-cart-sum__label"><strong>Zakupy od 149 zł wysyłamy gratis!</strong></p>
      </div>
      <BlockCartActions :isLogged="true" :linkOrder="linkOrder" :first="false" v-if="products.length >= 4" />
      <BlockCartActionsLog :isLogged="isLogged" @toggleOpened="toggleOpened" />
    </div>
</template>

<script>
import { BlockCartConfig, trinyConfig } from '@/config'
import Counter from '@/components/Counter.vue'
import BlockCartSummary from './BlockCartSummary.vue'
import BlockCartActions from './BlockCartActions.vue'
import BlockCartActionsLog from './BlockCartActionsLog.vue'

export default {
  props: ['products', 'counterDisabled', 'productTotal', 'shippingCost', 'isDisabled'],
  data () {
    return {
      options: Array.from(new Array(15), (x, i) => i + 1),
      isHovered: false,
      isOpened: false,
      isFirst: false,
      linkOrder: BlockCartConfig.linkOrder,
      isLogged: trinyConfig.logged,
      disabledDown: this.quantity === 1
    }
  },
  components: {
    Counter,
    BlockCartSummary,
    BlockCartActions,
    BlockCartActionsLog
  },
  methods: {
    changeQuantity (index, quantity, current, operator) {
      this.$emit('updateQuantity', {
        quantity: quantity,
        current: current,
        index: index,
        operator: operator
      })
    },

    toggleOpened () {
      this.$emit('hideProductsLogin')
    },
    increasing (current) {
      this.changeQuantity({
        index: this.index,
        quantity: 1,
        current: this.current,
        operator: 'up'
      })

      this.toggleDownDisable()
    },
    decrease (current) {
      if (this.current > 1) {
        this.changeQuantity({
          index: this.index,
          quantity: 1,
          current: this.current,
          operator: 'down'
        })
      }
      // this.$emit('maximum', {
      //   index: this.index,
      //   quantity: this.current
      // })

      this.toggleDownDisable()
    },

    toggleDownDisable () {
      if (this.current === 1) {
        this.disabledDown = true
      } else {
        this.disabledDown = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BlockCart/BlockCartList.vue